
export default {
  share: {
    fullUrl: 'Komplett',
    shortUrl: 'Kurz',
    urlCopied: 'URL kopiert',
    clickToCopy: 'Klicke zum kopieren der URL',
    share: 'Teilen (klicke zum kopieren)',
    shareLink: 'Link teilen',
    short: 'Kurze URL',
    copyUrlInfo: 'Es kann ebenfalls die URL in der Adressleiste des Browsers kopiert werden.',
    urlShortened: 'URL gekürzt',
    shorteningNotPossible: 'Keine kurz URL möglich. Bitte die komplette URL verwenden',
    embedCodeCopied: 'Code zur Einbettung kopiert',
    embed: 'Einbettung auf anderer Website (klicken zum kopieren)',
    embedInstructions: 'Diesen Code zum Einbetten der Karte auf Ihrer Website benutzen'
  }
}
